import { AwardHistoryModalCellRederer, AwardHistoryModalCellRedererType, FullHistoryItems } from '../../../models/manual-award.model';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'cv-award-history-modal-cell-renderer',
    templateUrl: './cv-award-history-modal-cell-renderer.component.html',
    styleUrl: './cv-award-history-modal-cell-renderer.component.scss'
})
export class CvAwardHistoryModalCellRendererComponent implements ICellRendererAngularComp {

    awardHistoryItem: FullHistoryItems;
    awardHistoryModalCellRedererType = AwardHistoryModalCellRedererType;
    customClass: string;
    primaryText: string;
    secondaryText: string | undefined;
    columnType: AwardHistoryModalCellRedererType;

    constructor() { }

    get tooltipTextValue() {
        return `${this.primaryText}\n${this.secondaryText ?? ''}`;
    }

    agInit(params: ICellRendererParams<any, any, any> & AwardHistoryModalCellRederer): void {
        this.awardHistoryItem = params.data;
        this.customClass = params.customClass;
        this.primaryText = params.primaryText;
        this.secondaryText = params.secondaryText;
        this.columnType = params.columnType;
    }

    refresh(params: ICellRendererParams<any, any, any>): boolean {
        return true;
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }
}
